import React from 'react';
import {LoadingIndicator} from '@fupa/fupa-uikit';
import {Container} from 'app/components/match/matchLive/LivetickerCommon';

const LivetickerLoadingIndicator = ({message}) => {
  return (
    <Container>
      <LoadingIndicator message={message} bgColor={true} />
    </Container>
  );
};

export default LivetickerLoadingIndicator;
